import React from "react";
import { getViewInfo } from "src/common/attrView";
import { makeSimpleTextProps } from "src/common/attrView/componentsDefs";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { MakeLabelParams } from "../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../utils/getAttrLabelTreeData";
import { SimpleText } from "./SimpleText/SimpleText";

/**
 * это какое-то легаси дерьмо, приходится его тоже поддерживать
 */
export const makeTextAreaLabel = (params: MakeLabelParams) => {
  const { attribute } = params;
  const viewInfo = getViewInfo(attribute.viewType);
  const treeData = getAttrLabelTreeData(params.attribute, params.labelTreeData);
  const labels = treeData?.labels;
  if (!viewInfo || viewInfo.component?.view !== "SimpleText" || !labels)
    return null;
  const newValues = seedSeparators(
    labels.map((v, i) => ({
      content: v,
      key: `${i}:${v}`,
    })),
    "newLine",
  );
  return <SimpleText {...makeSimpleTextProps(newValues, viewInfo)} />;
};
